import { dataBulbSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBulbSolid = /*#__PURE__*/createIcon(dataBulbSolid)
export default IconBulbSolid
